import { useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';

/**
 * One line of text cut with an ellipsis; hovering shows the full text, but only when it was cut
 */
export default function TruncatedText({ children, ...typographyProps }) {
  const ref = useRef(null);
  const [truncated, setTruncated] = useState(false);
  const measure = () => {
    const element = ref.current;
    setTruncated(Boolean(element) && element.scrollWidth > element.clientWidth);
  };

  return (
    <Tooltip title={truncated ? children : ''} placement="top-start" enterDelay={300}>
      <Typography ref={ref} noWrap onMouseEnter={measure} onFocus={measure} {...typographyProps}>
        {children}
      </Typography>
    </Tooltip>
  );
}
